import cx from 'classnames'
import { useState, useEffect } from 'react'

interface RadioOption {
  id: string
  value: string
  title: string
  description: string
  testId?: string
}

interface RadioGroupProps {
  onChange: (value: string) => void
  options?: RadioOption[]
  defaultValue?: string
  disabled?: boolean
}

export default function RadioGroupType({
  onChange,
  options = [],
  defaultValue = '',
  disabled = false,
}: RadioGroupProps): JSX.Element {
  const [selectedValue, setSelectedValue] = useState<string>(defaultValue)

  // Update parent component when selected value changes
  useEffect(() => {
    if (selectedValue) {
      onChange(selectedValue)
    }
  }, [selectedValue, onChange])

  // Handle radio button change
  const handleChange = (value: string) => {
    setSelectedValue(value)
  }

  return (
    <div className="radio-group grid grid-cols-2 gap-4 my-2 w-full ">
      {options.map((option) => (
        <label
          key={option.id}
          htmlFor={`${option.value}`}
          className={cx(
            'flex cursor-pointer rounded-lg border-2 bg-white p-2 shadow-sm focus:outline-none hover:border-secondary !text-foreground',
            `${selectedValue === option.value && 'border-black-100'}`,
          )}
        >
          <input
            type="radio"
            name="radio-group"
            id={`${option.value}`}
            value={option.value}
            checked={selectedValue === option.value}
            onChange={() => handleChange(option.value)}
            disabled={disabled}
            data-testid={option.testId || `radio-${option.value}`}
            className="sr-only"
          />
          <span className="flex flex-col text-md !text-gray-200">
            <span className="font-bold">{option.title}</span>
            <span className="font-medium">{option.description}</span>
          </span>
        </label>
      ))}
    </div>
  )
}
